import axios from "axios";

export const KEY = "AIzaSyDdens4mCVhK5wsItTAraoxkMlwMitNFR4";

export default axios.create({
  baseURL: "https://www.googleapis.com/youtube/v3",
});
